import { format } from "date-fns";
import React from "react";
import { Div } from "./styeld";

interface HorizontalLineProps {
   date?: string | Date;
   children: React.ReactElement;
}

const HorizontalLine: React.FC<HorizontalLineProps> = ({ date, children }) => {
   return (
      <Div>
         <div className="d-flex flex-column border border-secondary position-relative">
            {date && (
               <span className="hr-years fw-bolder">
                  {format(new Date(date), "yyyy")}
               </span>
            )}
         </div>
         {children}
      </Div>
   );
};

export default HorizontalLine;
